<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiHelp } from "@mdi/js";
export default {
  name: "MdiHelp",
  data() {
    return {
      svgPath: mdiHelp,
    };
  },
};
</script>
